import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function Register() {

    const navigate = useNavigate()

    useEffect(() => {
        navigate("/set-password")
    }, [])

    return (
        <div>

        </div>
    )
}